import React, { useCallback, useMemo } from "react";
import { isArray } from "lodash";

import { CustomComponent } from "../../../store/types";
import { HeadsHash } from "./Dropdown-collection";
import { DropdownHeadProps, IDropdownHead, ObjectValue } from "./dropdown-types";
import { CircularProgress } from "@mui/material";

export const DropdownHead: React.FC<DropdownHeadProps> = ({
  value,
  placeholder = "Select",
  theme = "standard",
  isOpen,
  setIsOpen,
  disabled,
  errors,
  loading
}): JSX.Element => {
  type StringFromArrayType = (value: string[] | object[]) => string;

  const stringFromArray: StringFromArrayType = useCallback((value: string[] | object[]) => {
    if (!value.length) {
      return "";
    }

    const isStringArray = typeof value[0] === "string";
    const includeMoreThenOne: boolean = value.length > 1;

    return isStringArray
      ? includeMoreThenOne
        ? value.join(", ")
        : (value as string[])[0]
      : includeMoreThenOne
      ? (value as ObjectValue[])
          .map((selected: ObjectValue) =>
            selected.presentation_name ? selected.presentation_name : selected.name || selected.title
          )
          .join(", ")
      : (value as ObjectValue[])[0].name || ((value as ObjectValue[])[0].title as any);
  }, []);

  const valuePreview: string = useMemo(() => {
    if (typeof value === "string") {
      return value || placeholder;
    }

    if (isArray(value)) {
      return stringFromArray(value);
    }

    if (value?.title) {
      return value.title;
    }

    if (value?.name) {
      return value.presentation_name ? value.presentation_name : value.name;
    }

    return placeholder;
  }, [value]);

  const HeadComponent: CustomComponent<IDropdownHead> = HeadsHash[theme];

  return (
    <div className="head-wrap">
      {loading ? (
        <div className="flex-row-fc-fc">
          <CircularProgress size={30} />
        </div>
      ) : (
        <HeadComponent
          value={valuePreview}
          onClick={() => {
            if (!disabled) {
              setIsOpen?.(!isOpen);
            }
          }}
          disabled={disabled}
          isOpen={isOpen}
          theme={theme}
          placeholder={placeholder}
        />
      )}
      {errors?.length ? (
        <span className="error opacity-appearance">{errors?.length && errors?.map((item) => item)}</span>
      ) : null}
    </div>
  );
};
